import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Cookie from "js-cookie";
const userToken = Cookie.get("token");
const baseUrl = process.env.VUE_APP_BASE_API_URL;
Vue.use(VueAxios, axios);

Vue.use(axios);

const uploadMasterSHU = ({ state }) => {
  return new Promise((resolve, reject) => {
    axios
      .post(baseUrl + "/shu/upload", state.fileUpload,{
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: `Bearer ${userToken}`
        }
      })
      .then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
  });
};
export default {
  uploadMasterSHU
};
